<ng-container *ngFor="let item of menuItems; trackBy: trackByKey">
	<ng-container *ngIf="item.route || item.link?.url || item.commandName; else staticHeader">
		<ng-container *ngTemplateOutlet="menuItem; context: { item: item }"></ng-container>
	</ng-container>
	<ng-template #staticHeader>
		<span class="obg-menu-header" *ngIf="item.title" [innerHtml]="item.title | translate"></span>
	</ng-template>
	<ng-container *ngFor="let child of item.children; trackBy: trackByKey">
		<ng-container *ngTemplateOutlet="menuItem; context: { item: child, sectionName: item.key }"></ng-container>
	</ng-container>
	<ng-template #menuItem let-item="item" let-sectionName="sectionName">
		<ng-container *ngIf="item.route || item.link?.url; else commandMenuItem">
			<a
				class="obg-menu-item"
				[attr.test-id]="'menu.' + item.key"
				[attr.data-test-id]="'menu.' + item.key"
				[attr.role]="role === 'list' ? 'listitem' : undefined"
				[obgRouteLink]="{ route: item.route, url: item.link?.url }"
				[obgRouteLinkActive]="item.route"
				[obgRouteLinkActiveOptions]="itemRouteLinkActiveOptions(item)"
				[obgCommandDispatcher]="item.commandName"
				[obgInteraction]="uiInteraction"
				[target]="item.link?.target"
				(click)="selectedItem.emit({ item: item, sectionName: sectionName })"
			>
				<i *ngIf="!hideIcons && item.iconTag" [ngClass]="['icon', item.iconTag]"></i>
				<span class="text" *ngIf="item.title" [innerHtml]="item.title | translate"></span>
			</a>
		</ng-container>
		<ng-template #commandMenuItem>
			<a
				class="obg-menu-item"
				[attr.test-id]="'menu.' + item.key"
				[attr.data-test-id]="'menu.' + item.key"
				[attr.role]="role === 'list' ? 'listitem' : undefined"
				[obgCommandDispatcher]="item.commandName"
				[obgInteraction]="uiInteraction"
				[target]="item.link?.target"
				(click)="selectedItem.emit({ item: item, sectionName: sectionName })"
			>
				<i *ngIf="!hideIcons && item.iconTag" [ngClass]="['icon', item.iconTag]"></i>
				<span class="text" *ngIf="item.title" [innerHtml]="item.title | translate"></span>
			</a>
		</ng-template>
	</ng-template>
</ng-container>
